import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";

import { useCustomToolStore } from "../../store/custom-tool-store";
import { DocumentViewer } from "../../components/custom-tools/document-viewer/DocumentViewer";
import { TextViewer } from "../../components/custom-tools/text-viewer/TextViewer";
import { useSessionStore } from "../../store/session-store";
import { useAxiosPrivate } from "../../hooks/useAxiosPrivate";
import { docIndexStatus } from "../../helpers/GetStaticData";

let publicDocumentApi;
try {
  publicDocumentApi =
    require("../../plugins/prompt-studio-public-share/helpers/PublicShareAPIs").publicDocumentApi;
} catch {
  // The component will remain null of it is not available
}
function SummarizeView({ setOpenManageDocsModal, currDocIndexStatus }) {
  const [text, setText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errMsg, setErrMsg] = useState(null);
  const { details, selectedDoc, isPublicSource } = useCustomToolStore();
  const { sessionDetails } = useSessionStore();
  const axiosPrivate = useAxiosPrivate();
  const { id } = useParams();

  useEffect(() => {
    handleFetchContent();
  }, [selectedDoc]);

  useEffect(() => {
    if (currDocIndexStatus === docIndexStatus.done) {
      handleFetchContent();
    }
  }, [currDocIndexStatus]);

  const handleFetchContent = () => {
    setText("");
    setErrMsg(null);
    if (!selectedDoc) {
      return;
    }
    let url = `/api/v1/unstract/${sessionDetails?.orgId}/prompt-studio/file/${
      details?.tool_id
    }?document_id=${selectedDoc?.document_id}&view_type=${"SUMMARIZE"}`;
    if (isPublicSource && publicDocumentApi) {
      url = publicDocumentApi(id, selectedDoc?.document_id, "SUMMARIZE");
    }
    const requestOptions = {
      method: "GET",
      url,
    };

    setIsLoading(true);
    axiosPrivate(requestOptions)
      .then((res) => {
        const data = res?.data?.data?.data;
        setText(data);
      })
      .catch((err) => {
        if (err?.response?.status === 404) {
          setErrMsg(
            "Summary is not available. Please index or re-index to generate it."
          );
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <DocumentViewer
      doc={selectedDoc?.document_name}
      isLoading={isLoading}
      isContentAvailable={text?.length > 0}
      setOpenManageDocsModal={setOpenManageDocsModal}
      errMsg={errMsg}
    >
      <TextViewer text={text} />
    </DocumentViewer>
  );
}

SummarizeView.propTypes = {
  setOpenManageDocsModal: PropTypes.func.isRequired,
  currDocIndexStatus: PropTypes.string.isRequired,
};

export { SummarizeView };
